<template>
  <div>
    <van-skeleton
      title
      avatar
      :row="5"
      avatar-size="50px"
      :loading="loadFeed"
      avatar-shape="square"
      class="hand-skeleton"
    >
      <div class="feed-container" v-loading="loadFeed">
        <!-- v-show="hasThisFeed" -->
        <div class="feed-header flex">
          <div>
            <img
              :class="initAclass"
              src="../assets/image/cl_user_avatar.png"
              v-real-img="initUserAvatar"
              @click="viewThisAvatar($event)"
            />
          </div>
          <div class="header-right flex">
            <p class="user-name">{{ initUserName }}</p>
            <p>{{ creatDate }}</p>
          </div>
        </div>
        <div class="feed-body">
          <div class="feed-title">{{ initDetailTitle }}</div>
          <div class="feed-summary">{{ initDetailContent }}</div>
          <div
            class="admin-feed-container"
            v-html="adminFeedContent"
            ref="adminFeedContainer"
          ></div>
          <div class="feed-media">
            <div class="image-container flex">
              <div
                class="feed-img-wrap"
                v-for="(item, index) in imageList"
                :key="index"
              >
                <img :src="item" alt @click.stop="handlePreview(index)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-skeleton>
    <div class="no-feed-container" v-show="!hasThisFeed">
      <div class="no-this-feed">
        <img src="../assets/image/cl_mobile_withdraw.png" alt />
        <p class="tip-text">抱歉，内容被作者收回了</p>
      </div>
    </div>
    <div class="company-container">
      <p class="mobile-logo">
        <img src="../assets/image/cl_mobile_logo.png" alt />
      </p>
      <p class="mobile-slogan">
        <img src="../assets/image/cl_mobile_slogan.png" alt />
      </p>
      <p class="mobile-download">
        <a id="downloadBtn" href="javascript:;">下载传联APP</a>
      </p>
      <p class="company-name">贵州传联网络科技有限公司</p>
      <p class="company-domain">www.handlian.com</p>
    </div>
  </div>
</template>
<script>
import { apiMap } from "../utils/apiMap";
import { getFullDate } from "../utils/date";
import { htmlFilter } from "../utils/feed";
import userAvatar from "../assets/image/cl_user_avatar.png";
import adminAvatar from "../assets/image/cl_admin_avatar.png";
export default {
  name: "weixin-share",
  data() {
    return {
      loadFeed: true,
      hasThisFeed: true,
      imageList: [],
      feed: {},
      adminFeedContent: "",
    };
  },
  computed: {
    initAclass() {
      if (this.feed.userType == 1) {
        return "user-avatar";
      } else {
        return "admin-avatar";
      }
    },
    initUserAvatar() {
      if (this.feed.hasOwnProperty("userInfo")) {
        if (this.feed.userType == 1) {
          if (/^(https:|http:|\/\/)/.test(this.feed.userInfo.thumbHeadImg)) {
            return this.feed.userInfo.thumbHeadImg;
          } else {
            return userAvatar;
          }
        } else {
          return adminAvatar;
        }
      }
    },
    initDetailTitle() {
      return htmlFilter(this.feed.title);
    },
    initDetailContent() {
      if (this.feed.userType == 1) {
        if (this.feed.modelType == 1) {
          return htmlFilter(this.feed.content);
        } else {
          if (this.feed.introduction != "null") {
            return htmlFilter(this.feed.introduction);
          }
        }
      }
    },
    creatDate() {
      if (this.feed.hasOwnProperty("created_at")) {
        return getFullDate(new Date(this.feed.created_at * 1000));
      }
    },
    initUserName() {
      if (this.feed.hasOwnProperty("userInfo")) {
        return this.feed.userInfo.name;
      }
    },
  },
  beforeMount() {
    // console.log(this.$route.query)
    this.getFeedDetail();
  },
  mounted() {
    this.getApk();
  },
  methods: {
    getFeedDetail() {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["feedDetail"]["method"],
          url: apiMap["feedDetail"]["url"],
          params: {
            modelId: _this.$route.query.feedID,
            modelType: _this.$route.query.feedType,
            self: 2,
          },
        })
        .then(function (response) {
          _this.loadFeed = false;
          if (response.data.result.statusCode == 1) {
            _this.feed = response.data.result.data;
            if (_this.feed.modelType == 1 || _this.feed.modelType == 2) {
              if (/^(https:|http:|\/\/)/.test(_this.feed.uriKey[0])) {
                _this.imageList = _this.feed.uriKey;
              }
            }
            if (response.data.result.data.userType == 2) {
              _this.adminFeedContent = response.data.result.data.content;
              setTimeout(() => {
                _this.initImageEvent();
              }, 1000);
            }
          } else {
            _this.hasThisFeed = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    iniDetailIntro() {
      if (this.feed.introduction != "null") {
        return this.feed.introduction;
      } else {
        return "";
      }
    },
    handlePreview(index) {
      this.$store.dispatch("pushImageList", this.imageList);
      this.$router.push({
        path: "/imageView",
        query: {
          index: index,
        },
      });
    },
    viewThisAvatar(obj) {
      if (obj.target.src) {
        var avatarUrl = [obj.target.src];
        this.$store.dispatch("pushImageList", avatarUrl);
        this.$router.push({
          path: "/imageView",
          query: {
            index: "avatar",
          },
        });
      }
    },
    initImageEvent() {
      let _this = this;
      var imgList = _this.$refs.adminFeedContainer.querySelectorAll("img");
      var allPhotos = [];
      for (let index = 0; index < imgList.length; index++) {
        const element = imgList[index];
        allPhotos.push(element.src);
        element.addEventListener("click", function () {
          _this.$router.push({
            path: "/imageView",
            query: {
              index: index,
            },
          });
        });
      }
      if (imgList.length > 0) {
        _this.$store.dispatch("pushImageList", allPhotos);
      }
    },
    getApk() {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["appLink"]["method"],
          url: apiMap["appLink"]["url"],
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            var element = document.querySelector("#downloadBtn");
            element.setAttribute("href", response.data.result.data.Android.uri);
            var ua = navigator.userAgent.toLowerCase();
            console.log(ua);
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
              element.addEventListener("click", function () {
                alert("请点击右上角按钮，并选择浏览器打开");
              });
              element.setAttribute("href", "javascript:;");
            } else if (ua.match(/QQ\//i) == "qq/") {
              element.setAttribute(
                "href",
                response.data.result.data.Android.uri
              );
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.hand-skeleton {
  padding-top: 15px;
  padding-bottom: 25px;
  background-color: #ffffff;
}

.feed-container {
  padding: 10px;
  min-height: 50px;
  background-color: #ffffff;
}

.company-container {
  margin-top: 10px;
  padding-top: 20px;
  text-align: center;
  background-color: #ffffff;
}

.user-avatar {
  width: 16vw;
  height: 16vw;
  object-fit: cover;
  border: 1px solid #f5f5f5;
}

.admin-avatar {
  width: 16vw;
  height: 16vw;
  object-fit: cover;
}

.user-name {
  font-size: 16px;
  font-weight: bold;
}

.header-right {
  margin-left: 10px;
  flex-direction: column;
  justify-content: space-evenly;
}

.feed-body {
  margin-top: 0.4rem;
  padding: 0.4rem;
  border: 1px solid #eeeeee;
  border-radius: 3px;
}

.mobile-logo {
  width: 25.6vw;
  height: 28vw;
  margin: 1rem auto 1rem;
}

.mobile-slogan {
  width: 59vw;
  height: 6vw;
  margin: 0 auto;
}

.mobile-logo img {
  width: 100%;
}

.mobile-slogan img {
  width: 100%;
}

.mobile-download {
  width: 58vw;
  height: 8vw;
  margin: 1rem auto 1rem;
  line-height: 8vw;
  background-color: #0071ff;
  border-radius: 4px;
}

.mobile-download a {
  display: block;
  color: #ffffff;
  font-size: 16px;
}

.company-name {
  color: #888888;
  font-size: 16px;
  line-height: 8vw;
}

.company-domain {
  margin-bottom: 1rem;
  font-size: 16px;
  color: #888888;
  line-height: 5vw;
}

.no-feed-container {
  padding: 15px 0;
  background-color: #ffffff;
}

.no-this-feed {
  width: 180px;
  margin: 20px auto 15px;
}

.no-this-feed img {
  width: 100%;
}

.tip-text {
  margin-top: 7px;
  color: #999;
  line-height: 30px;
  text-align: center;
}

.feed-title {
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.feed-content {
  font-size: 16px;
  font-weight: 500;
  line-height: 25px;
  color: #333;
  white-space: pre-wrap;
  text-align: justify;
}

.feed-summary {
  /* text-align: justify; */
  line-height: 25px;
  white-space: pre-wrap;
  overflow: hidden;
}

.admin-feed-container {
  overflow: auto;
}

.image-container {
  flex-wrap: wrap;
}

.feed-img-wrap {
  width: 28vw;
  height: 28vw;
  margin: 5px 5px 0 0;
}

.feed-img-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.feed-img-wrap video {
  max-width: 100%;
}
</style>